import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 65,
    paddingHorizontal: 20
  },
  arrow: {
    width: '6'
  },
  image: {
    width: '2%',
    marginLeft: '20px',
    alignItems: 'flex-start'
  },
  spacing: {
    width: '97',
    alignItems: 'flex-start',
    alignContent: 'space-between',
    marginTop: '5',
    marginBottom: '5',
    maxLines: 1,
    textOverflow: 'ellipsis'
  },

  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  }
});

const PatientRoundsPdfTableFile = ({ data }: any) => {
  return (
    <Document>
      <Page style={styles.body} orientation="landscape" wrap>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between'
          }}
          fixed
        >
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              alignItems: 'flex-start',
              borderBottomColor: 'black',
              borderBottomWidth: 1,
              marginBottom: 7,
              marginTop: 20,
              fontWeight: 'bold'
            }}
          >
            <Text style={{ fontSize: 12, marginLeft: 0 }}>Unit</Text>
            <Text style={{ fontSize: 12, marginLeft: 140 }}>Room</Text>
            <Text style={{ fontSize: 12, marginLeft: 65 }}>Patient & MRN</Text>
            <Text style={{ fontSize: 12, marginLeft: 107 }}>Status</Text>
            <Text style={{ fontSize: 12, marginLeft: 69 }}>Rounded By</Text>
            <Text style={{ fontSize: 12, marginLeft: 70 }}>Date & Time</Text>
          </View>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
          />
        </View>
        {data.map((s: any) => (
          <View
            key={s.accountNumber}
            style={{
              fontSize: 8,
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
            wrap={false}
          >
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                marginRight: '20'
              }}
              wrap={false}
            >
              <View style={{ ...styles.spacing, width: 130 }}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>{s.unit}</Text>
                <Text>{s.unitId}</Text>
              </View>
              <View style={{ ...styles.spacing, width: 50 }}>
                <Text>{s.room}</Text>
              </View>
              <View style={styles.spacing}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.patient}
                </Text>
                <Text>{s.patientMRN}</Text>
              </View>
              <View style={{ ...styles.spacing, width: 115, paddingLeft: 50 }}>
                <Text>{s.status}</Text>
              </View>
              <View style={styles.spacing}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.createdUserName}
                </Text>
                <Text>{s.createdUserId}</Text>
              </View>
              <View style={styles.spacing}>
                <Text>
                  {s.date} @ {s.time}
                </Text>
              </View>
            </View>
          </View>
        ))}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PatientRoundsPdfTableFile;
